/**
 * 404. The legacy app had no equivalent — an unknown `showView` name threw a
 * TypeError on a null element and left a blank screen.
 */

import { Link } from 'react-router-dom';
import { Icon, Panel } from '../../components/common';
import { useAuth } from '../../context/AuthContext';

export function NotFoundPage() {
  const { session, homePath } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center app-backdrop p-4">
      <Panel className="w-full max-w-md text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-800 text-slate-500">
          <Icon name="map-pin-off" size={30} />
        </div>

        <h1 className="mb-2 text-xl font-bold text-white">الصفحة غير موجودة</h1>
        <p className="mb-6 text-sm leading-relaxed text-slate-400">
          الرابط الذي فتحته غير صحيح أو تم نقل الصفحة.
        </p>

        <Link to={session ? homePath : '/login'} className="btn-primary mx-auto w-fit">
          <Icon name="home" size={16} />
          {session ? 'العودة للرئيسية' : 'تسجيل الدخول'}
        </Link>
      </Panel>
    </div>
  );
}

export default NotFoundPage;
